import { useMemo } from 'react';
import { currentTimeInZone, formatTime12, isToday } from '../lib/dates.js';
import { STATUS_COMPLETED, STATUS_CANCELLED, STATUS_UPCOMING } from '../lib/constants.js';

/**
 * Total / next / completed for the selected day.
 *
 * "Next" means the first upcoming appointment still ahead on the clock when the
 * selected day is today. On any other day the clock is not meaningful, so it
 * shows the first upcoming appointment of that day instead.
 */
export default function Stats({ meetings, selectedDate }) {
  const { total, completed, next } = useMemo(() => {
    const now = currentTimeInZone();
    const viewingToday = isToday(selectedDate);

    const upcoming = meetings
      .filter((meeting) => meeting.status === STATUS_UPCOMING)
      .filter((meeting) => (viewingToday ? meeting.time >= now : true));

    return {
      total: meetings.length,
      completed: meetings.filter((m) => m.status === STATUS_COMPLETED).length,
      next: upcoming[0] || null,
    };
  }, [meetings, selectedDate]);

  const cancelled = meetings.filter((m) => m.status === STATUS_CANCELLED).length;

  return (
    <section className="stats" aria-label="إحصائيات اليوم">
      <div className="stat-card">
        <span className="stat-label">الموعد القادم</span>
        {next ? (
          <>
            <span className="stat-value is-text">{next.title}</span>
            <span className="stat-detail" dir="rtl">
              {formatTime12(next.time)}
            </span>
          </>
        ) : (
          <span className="stat-value is-text muted">لا يوجد</span>
        )}
      </div>

      <div className="stat-card">
        <span className="stat-label">إجمالي المواعيد</span>
        <span className="stat-value">{total}</span>
        {cancelled > 0 && <span className="stat-detail">منها {cancelled} ملغى</span>}
      </div>

      <div className="stat-card">
        <span className="stat-label">المنجزة</span>
        <span className="stat-value">{completed}</span>
        {total > 0 && (
          <span className="stat-detail">
            {Math.round((completed / total) * 100)}٪ من اليوم
          </span>
        )}
      </div>
    </section>
  );
}
